<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 pb-52 pt-6">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 max-w-5xl pb-20">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center pt-5">
          DESCARGAR MI CREDENCIAL
        </h1>
        <h1 class="text-gray-800 mb-4 text-2xl text-center pt-2 pb-5">
          Por favor ingresá el DNI con el que te registraste para descargar tu credencial
        </h1>

        <!-- Formulario -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <Field name="mailDni" v-slot="{ field, errors }" v-model="formData.mailDni">
              <InputText v-bind="field" type="text"  placeholder="Mail o DNI"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mailDni" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="button" @click="buscarAcreditado"
            class="mt-2 px-4 py-2 bg-transparent border-blue-950 hover:bg-black text-blue-950 font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>CONTINUAR
          </button>
        </div>
    
        <div v-if="isFormularioVisible" class="w-full">
          <div class="flex flex-col items-center text-center rounded-lg shadow-lg mt-4 bg-gray-200" >
            <h1 class="mb-4 text-xl text-center pb-1 mt-4 text-black">
              Hacé click en el siguiente botón para descargar tu entrada
            </h1>
            <div class="flex flex-wrap py-2 mb-4 gap-3">
              <button @click="descargarArchivo" class="mt-2 px-4 py-2 bg-black border-black hover:bg-white text-white hover:text-black border rounded">
                <i class="pi pi-qrcode mr-2"></i>DESCARGAR MI ENTRADA
              </button>
              <button @click="cancelarAcreditacion" type="button" class="mt-2 px-4 py-2 bg-black border-black hover:bg-white text-white hover:text-black border rounded">
                <i class="pi pi-check mr-2"></i>TERMINAR
              </button>
            </div>
          </div>
        </div>

        <div class="text-sm pt-6">&bull; Si todavía no estas registrado podes acreditarte haciendo <a class="font-semibold" href="/agrievolution/">click aquí</a></div>

      </div>
    
      <BlockUI :blocked="isSubmitting" fullScreen />
      
    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';


export default defineComponent({
  components: {
    InputText, HeaderSection,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      isSubmitting: false,
      isFormularioVisible: false,
      urlCredencial: '',
      formData: {
        mailDni: ''
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        mailDni : yup.string().required('Ingrese tu mail o DNI'),
      });
    }
  },
  methods: {
    cancelarAcreditacion() {
      this.$router.go(0);
    },  
    async descargarArchivo() {
      const response = await fetch(this.urlCredencial);
      const blob = await response.blob();
      const urlBlob = URL.createObjectURL(blob);

      const enlace = document.createElement("a");
      enlace.href = urlBlob;
      enlace.download = "certificado.pdf";
      enlace.click();

      URL.revokeObjectURL(urlBlob);
    },
    async buscarAcreditado() {
      this.isSubmitting = true;

      try {
        let acreditado:Acreditado = await suiteService.findAcreditadoByDni(suiteConfig.evento, this.formData.mailDni);
        if(!acreditado) {
            Swal.fire({ title: "Error", text: 'No encontramos ningún acreditado con ese DNI', icon: "error" });
            this.isSubmitting = false;
            return;
        }

        this.isFormularioVisible = true;
        this.urlCredencial = "https://apps.qreventos.com/credencial/getCredencial?credencial=256&evento=507&pdf=true&hash=" + acreditado.hash;

      } catch(error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }

    },    
    async onSubmit() {
      this.isSubmitting = false;
    }
  },
});
</script>